/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseType: NonNullable<unknown> }} Case_Type_BlurbInputs */

const en_case_type_blurb = /** @type {(inputs: Case_Type_BlurbInputs) => LocalizedString} */ (i) => {
	if (i?.caseType === "third_party_claim") return /** @type {LocalizedString} */ (`Collision or damage caused by another vehicle.`);
	if (i?.caseType === "road_conditions") return /** @type {LocalizedString} */ (`Pothole, object, or animal on the road.`);
	if (i?.caseType === "debt_collection") return /** @type {LocalizedString} */ (`Collect an overdue debt from an individual or company.`);
	return /** @type {LocalizedString} */ (`${i?.caseType}`)
	
};

const pt_br2_case_type_blurb = /** @type {(inputs: Case_Type_BlurbInputs) => LocalizedString} */ (i) => {
	if (i?.caseType === "third_party_claim") return /** @type {LocalizedString} */ (`Colisão ou dano causado por outro veículo.`);
	if (i?.caseType === "road_conditions") return /** @type {LocalizedString} */ (`Buraco, objeto ou animal na pista.`);
	if (i?.caseType === "debt_collection") return /** @type {LocalizedString} */ (`Cobrança de dívida vencida de pessoa física ou jurídica.`);
	return /** @type {LocalizedString} */ (`${i?.caseType}`)
	
};

/**
* | caseType | output |
* | --- | --- |
* | "third_party_claim" | "Collision or damage caused by another vehicle." |
* | "road_conditions" | "Pothole, object, or animal on the road." |
* | "debt_collection" | "Collect an overdue debt from an individual or company." |
* | * | "{caseType}" |
*
* @param {Case_Type_BlurbInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_blurb = /** @type {((inputs: Case_Type_BlurbInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_BlurbInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_blurb(inputs)
	return pt_br2_case_type_blurb(inputs)
});